module.exports = __webpack_public_path__ + "media/images/home/watch-0e61a6e64a77d3bab0bd9ea2fe535e77.png";